import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { Menu, MenuItem, } from '@mui/material'
import './go.css'
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';

import { M_Select, M_MessageBoard, M_CheckBox, M_ElementDrawer, M_Table, M_InputTextField, M_Button, LoadingContext, DefaultURl, filtersSortService, BufferService, M_Fieldset } from 'src/M_Components'

const BookingList = ({ roles, onCreateTab, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [isLabel, setIsLabel] = useState(true)
    const [drawerEntity, setDrawerEntity] = useState('shipment')
    const [drawerLabel, setDrawerLabel] = useState('')
    const [onOpen, setOnOpen] = useState(false)
    const [openElement, setOpenElement] = useState(false)
    const tempFilterName = sessionStorage.getItem('filterName') ? sessionStorage.getItem('filterName') : ''
    const tempFilter = sessionStorage.getItem('filter') !== null ? new Map([[tempFilterName, sessionStorage.getItem('filter')]]) : new Map()
    const [filter, setFilter] = useState(tempFilter)
    const [filterName, setFilterName] = useState(tempFilterName)
    const [VGMDict, setVGMDict] = useState(new Map())
    const [refresh, setRefresh] = useState(false)
    const [refreshSubTables, setRefreshSubTables] = useState(false)
    const [FILTERIMO, setFILTERIMO] = useState('')
    const [FILTERVGM, setFILTERVGM] = useState('')
    const [isBookingEquipmentSelected, setIsBookingEquipmentSelected] = useState(false)

    const [transportValue, setTransportValue] = useState(null)
    const [confirmModal, setConfirmModal] = useState(false)

    const ctx = useContext(LoadingContext)

    const [shipId, setShipId] = useState('')
    const [action, setAction] = useState('')
    const [anchorIMO, setAnchorIMO] = useState(null)
    const [anchorVGM, setAnchorVGM] = useState(null)

    const [openDeleteLine, setOpenDeleteLine] = useState(false)
    const [openDeleteContext, setOpenDeleteContext] = useState(false)

    const [contextMenu, setContextMenu] = useState([])
    const [extraButtons, setExtraButtons] = useState([])

    const shipmentBuffer = new BufferService('shipment')
    const shipmentDetailsBuffer = new BufferService('shipmentDetail')
    const bookingEquipmentService = new BufferService('BookingEquipment')
    const BLService = new BufferService('BL')
    const filterService = new filtersSortService()
    const hiddenFileInputUploadIMO = React.useRef(null)
    const hiddenFileInputUploadVGM = React.useRef(null)

    const bookingV2Service = new BufferService('viewbooking')
    const MoveService = new BufferService('Booking/movebookingstotransport')

    const openIMO = Boolean(anchorIMO)
    const openVGM = Boolean(anchorVGM)

    useEffect(() => {
        sessionStorage.removeItem('filterName')
        sessionStorage.removeItem('filter')
        updatePermissions()
    }, [])

    const updatePermissions = () => {
        const perms = getPermissions('Context')
        setContextMenu(perms)
        const buttons = getPermissions('Buttons')
        setExtraButtons(buttons)
    }

    const getPermissions = (Type) => {
        const permBooking = []
        const permBL = []
        let permLines = []
        let permButtons = []
        const nameForRole = 'bookings'
        roles.forEach((role) => {
            if (role.match('blsCreate') || role.match('blsList')) permBL.push(role)
            if (role.match(nameForRole)) permBooking.push(role)
        })
        permLines.push({ label: t("LabelViewBooking"), icon: 'pi pi-search', command: () => operationBookingContext("go/viewBooking", "View") })
        if (permBooking.includes('bookingsCreate')) permButtons.push({ label: t("LabelCreateBooking"), element: <M_Button entity={'voyage'} tooltip={t("LabelCreateBooking")} label={t("LabelCreateBooking")} icon={<img src='/icons/tableIcons/add.svg' alt='Add Row' className="iconTable" />} onGetline={saveline} key={'bookingCreate'} tableLabel={'Voyages'} />, command: () => { } })
        if (permBooking.includes('bookingsEdit')) {
            permLines.push({ label: t("LabelEditBooking"), icon: 'pi pi-pencil', command: () => operationBookingContext("go/createBooking", 'Edit') })
            permButtons.push({ label: t("LabelEditBooking"), element: 'default', source: '/icons/tableIcons/edit.svg', style: {}, command: () => operationBookingLine("go/createBooking", 'Edit'), needLine: true })
            permButtons.push({ label: t("LabelMoveBookings"), element: <M_Button entity={'transport'} tooltip={t("LabelMoveBookings")} label={t("LabelMoveBookings")} icon={<AirlineStopsIcon style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }} />} onGetline={(obj) => { setConfirmModal(true); setTransportValue(obj) }} key={'moveBooking'} tableLabel={'Voyages'} />, command: () => { } })
        }
        if (permBooking.includes('bookingsCreate')) {
            permLines.push({ label: t("LabelCopyBooking"), icon: 'pi pi-copy', command: () => operationBookingContext("go/createBooking", 'Copy') })
            permButtons.push({ label: t("LabelCopyBooking"), element: 'default', source: '/icons/tableIcons/copy.svg', style: {}, command: () => operationBookingLine("go/createBooking", 'Copy') })
        }
        if (permBooking.includes('bookingsDelete')) {
            permLines.push({ label: t("LabelDeleteBooking"), icon: 'pi pi-trash', command: () => setOpenDeleteContext(true), needLine: true })
            permButtons.push({ label: t("LabelDeleteBooking"), element: 'default', source: '/icons/svgsDaNet/trash-2.svg', style: { filter: 'invert(11%) sepia(68%) saturate(6715%) hue-rotate(359deg) brightness(93%) contrast(115%)' }, command: () => setOpenDeleteLine(true), needLine: true })
        }
        permLines.push({ separator: true })
        permLines.push({ label: t("ViewInvoices"), icon: 'pi pi-search', command: () => {
            const booking = JSON.parse(sessionStorage.getItem('context'))
            NewRoute(`go/invoiceList/${booking.Id}`, `${t("InvoicesForBooking")} ${booking.BookingNumber}`)
        }, needLine: true })
        permLines.push({ label: t("ViewShipmentCharges"), icon: 'pi pi-search', command: () => {
            const booking = JSON.parse(sessionStorage.getItem('context'))
            NewRoute(`go/shipmentChargesList/${booking.Id}`, `${t("ShipmentChargesForBooking")} ${booking.BookingNumber}`)
        }, needLine: true })

        if (permBL.includes('blsCreate')) {
            // Vamos espreitar se a linha clicada tem a data
            const contextData = JSON.parse(sessionStorage.getItem('bookingLine') || '{}')
            // Só adiciona ao menu se a data NÃO for nula
            if (contextData.ContainerInsertedDate) {
                permLines.push({
                    label: t("LabelCreateBL"),
                    icon: 'pi pi-plus-circle',
                    command: () => operationBookingContext("go/createBL", "Create BL")
                })
            }

            // Para o botão da barra superior (permButtons), ele precisa de uma linha selecionada
            permButtons.push({
                label: t("LabelCreateBL"),
                element: 'default',
                source: '/icons/tableIcons/add.svg',
                style: {},
                command: () => operationBookingLine("go/createBL", "Create BL"),
                needLine: true // Garante que só funciona com linha selecionada
            })
        }
        if (permBL.includes('blsList')) permLines.push({ label: t("LabelViewBL"), icon: 'pi pi-search', command: () => viewBL("go/viewBL", "View BL") })
        permLines.push({ separator: true })
        if (permBooking.includes('bookingsEdit')) {
            permLines.push({ label: 'IMO', icon: 'pi pi-info-circle', command: () => openDrawerDetailsIMO() })
            permLines.push({ separator: true })
            permLines.push({ label: 'VGM', icon: 'pi pi-info-circle', command: () => openDrawerDetailsVGM() })
            permButtons.push({ label: 'IMO', element: 'default', source: '/icons/svgsDaNet/info.svg', style: { filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }, command: () => openDrawerDetailsIMO() })
            permButtons.push({ label: 'VGM', element: 'default', source: '/icons/svgsDaNet/info.svg', style: { filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }, command: () => openDrawerDetailsVGM() })
        }
        if (Type === 'Context') return permLines
        if (Type === 'Buttons') return permButtons
    }

    const bufferRoute = (url, label,) => {
        if (sessionStorage.getItem('contextLine') === 'undefined') {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        NewRoute(url, label)
    }

    const NewRoute = (url, label, stateToPass) => {
        navigate(`${url}`)
        onCreateTab(url, label)
    }

    const deleteBookingContext = () => {
        let tempData = sessionStorage.getItem('context')
        if (tempData === 'undefined' || tempData === null || tempData === undefined || tempData === 'null') {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        sessionStorage.removeItem('context')
        bookingV2Service.delete(JSON.parse(tempData).Id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', ResData.response.data.Message, '')
                setOpenDeleteContext(false)
                return
            }
            setOpenDeleteContext(false)
            ctx.toastMessages('success', '', `Booking ${ResData.BookingNumber} ${t("LabelEliminated")}`)
            setTimeout(function () {
                setRefresh(true)
            }, 1000)
        })
    }

    const deleteBookingLine = () => {
        let tempData = sessionStorage.getItem('lines')
        if (tempData === 'undefined' || tempData === null || tempData === undefined || tempData === 'null') {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        tempData = JSON.parse(tempData)
        sessionStorage.removeItem('lines')
        tempData.forEach(obj => {
            bookingV2Service.delete(obj.Id).then(ResData => {
                if (ResData.name === 'AxiosError') {
                    ctx.toastMessages('error', ResData.response.data.Message, '')
                    setOpenDeleteLine(false)
                    return
                }
                setOpenDeleteLine(false)
                ctx.toastMessages('success', '', `Booking ${ResData.BookingNumber} ${t("LabelEliminated")}`)
                setRefresh(true)
            })
        })
    }

    const operationBookingLine = (url, operation) => {
        let tempData = sessionStorage.getItem('lines')
        if (tempData === 'undefined' || tempData === null || tempData === undefined || tempData === 'null') {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }

        tempData = JSON.parse(tempData).pop()

        sessionStorage.removeItem('lines')
        sessionStorage.setItem('operation', operation)
        sessionStorage.setItem('bookingLine', JSON.stringify(tempData))
        if (operation === 'Edit') {
            NewRoute(url, `Edit Booking ${tempData.BookingNumber}`)
        }
        if (operation === 'Create') {
            NewRoute(url, 'Create Booking')
        }
        if (operation === 'Copy') {
            NewRoute(url, 'Copy Booking')
        }
        if (operation === 'View') {
            NewRoute(url, `View Booking ${tempData.BookingNumber}`)
        }
        if (operation === 'Create BL') {
            if (tempData.BookingStatus !== 'Approved') {
                ctx.toastMessages('error', '', t("LabelBookingNotApprov"))
                return
            }
            if (tempData.BLId !== null) {
                ctx.toastMessages('error', '', t("LabelBookingHasBL"))
                return
            }
            if (!tempData.ContainerInsertedDate) {
                ctx.toastMessages('error', '', t("LabelWaitingContainerNumbers"))
                return
            }
            sessionStorage.removeItem('bookingLine')
            sessionStorage.setItem('blContext', JSON.stringify(tempData))
            sessionStorage.setItem('operation', 'Create')
            NewRoute(url, `Create BL ${tempData.BookingNumber}`)
        }
    }

    const operationBookingContext = (url, operation) => {
        let tempData = sessionStorage.getItem('context')
        if (tempData === 'undefined' || tempData === null || tempData === undefined || tempData === 'null') {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        tempData = JSON.parse(tempData)
        sessionStorage.setItem('bookingLine', JSON.stringify(tempData))
        sessionStorage.setItem('operation', operation)
        if (operation === 'Edit') {
            NewRoute(url, `Edit Booking ${tempData.BookingNumber}`)
        }
        if (operation === 'Create') {
            NewRoute(url, 'Create Booking')
        }
        if (operation === 'Copy') {
            NewRoute(url, 'Copy Booking')
        }
        if (operation === 'View') {
            NewRoute(url, `View Booking ${tempData.BookingNumber}`)
        }
        if (operation === 'Create BL') {
            if (tempData.BookingStatus !== 'Approved') {
                ctx.toastMessages('error', '', t("LabelBookingNotApprov"))
                return
            }
            if (tempData.BLId !== null) {
                ctx.toastMessages('error', '', t("LabelBookingHasBL"))
                return
            }
            if (!tempData.ContainerInsertedDate) {
                ctx.toastMessages('error', '', t("LabelWaitingContainerNumbers"))
                return
            }
            sessionStorage.removeItem('bookingLine')
            sessionStorage.setItem('blContext', JSON.stringify(tempData))
            sessionStorage.setItem('operation', 'Create')
            NewRoute(url, `Create BL ${tempData.BookingNumber}`)
        }
    }

    const openDrawerUploadIMO = () => {
        if (sessionStorage.getItem('contextLine') !== 'undefined') {
            setAnchorIMO(null)
            const tempId = JSON.parse(sessionStorage.getItem('contextLine'))

            setAction('uploadIMO')
            setDrawerEntity('shipment')
            setDrawerLabel('Shipments')
            setFilter(new Map([[tempId.BookingNumber, `?page=1&pagesize=20&filter= IdBooking eq ${tempId.Id}`]]))
            setFilterName(tempId.BookingNumber)
            setOnOpen(true)
        } else {
            ctx.toastMessages('error', '', t("SelectedLine"))
        }
    }

    const openDrawerDetailsIMO = () => {
        setShipId('')
        if (sessionStorage.getItem('contextLine') !== 'undefined') {
            setAnchorIMO(null)
            const tempId = JSON.parse(sessionStorage.getItem('contextLine'))
            if (tempId.BookingSummary === null) {
                ctx.toastMessages('error', '', t("BookingNoShipments"))
                return
            }
            setAction('downloadIMO')
            setDrawerEntity('shipment')
            setDrawerLabel('Shipments')
            setFILTERIMO(`IdBooking eq ${tempId.Id}`)
            setOnOpen(true)
        } else {
            ctx.toastMessages('error', '', t("SelectedLine"))
        }
    }

    const openDrawerUploadVGM = () => {
        if (sessionStorage.getItem('contextLine') !== 'undefined') {
            setAnchorVGM(null)
            const tempId = JSON.parse(sessionStorage.getItem('contextLine'))
            shipmentBuffer.filter(`?filter=IdBooking eq ${tempId.Id}`).then(dataShipment => {
                if (dataShipment.name === 'AxiosError') {
                    ctx.toastMessages('error', dataShipment.nessage, '')
                    return
                }
                const tempShipArray = dataShipment.Items

                let tempShipString = filterService.advancedSearch(tempShipArray.map(obj => {
                    return { name: 'IdShipment', type: 'int32', operation: 'Equals', value: obj.Id }
                }))

                tempShipString = tempShipString.replaceAll('and', 'or')
                shipmentDetailsBuffer.filter(`?${tempShipString}`).then(dataShipmentDetail => {
                    if (dataShipment.name === 'AxiosError') {
                        ctx.toastMessages('error', dataShipmentDetail.message, '')
                        return
                    }
                    const tempShipDetailArray = dataShipmentDetail.Items
                    let tempShipDetailsString = filterService.advancedSearch(tempShipDetailArray.map(obj => {
                        return { name: 'Id', type: 'int32', operation: 'Equals', value: obj.IdBookingEquipment }
                    }))
                    tempShipDetailsString = tempShipDetailsString.replaceAll('and', 'or')
                    // console.log(tempShipDetailsString)
                    setAction('uploadVGM')
                    setDrawerEntity('bookingEquipment')
                    setDrawerLabel('Booking Equipment')
                    setFilter(new Map([[tempId.BookingNumber, `?page=1&pagesize=20${tempShipDetailsString}`]]))
                    setFilterName(tempId.BookingNumber)
                    setOnOpen(true)
                })
            })
        } else {
            ctx.toastMessages('error', '', t("SelectedLine"))
        }
    }

    const openDrawerDownloadVGM = () => {
        if (sessionStorage.getItem('contextLine') !== 'undefined') {
            setAnchorVGM(null)
            const tempId = JSON.parse(sessionStorage.getItem('contextLine'))

            shipmentBuffer.filter(`?filter=IdBooking eq ${tempId.Id}`).then(dataShipment => {
                if (dataShipment.name === 'AxiosError') {
                    ctx.toastMessages('error', dataShipment.message, '')
                    return
                }
                const tempShipArray = dataShipment.Items

                let tempShipString = filterService.advancedSearch(tempShipArray.map(obj => {
                    return { name: 'IdShipment', type: 'int32', operation: 'Equals', value: obj.Id }
                }))

                tempShipString = tempShipString.replaceAll('and', 'or')
                shipmentDetailsBuffer.filter(`?${tempShipString}`).then(dataShipmentDetail => {
                    if (dataShipment.name === 'AxiosError') {
                        ctx.toastMessages('error', dataShipmentDetail.message, '')
                        return
                    }

                    const tempShipDetailArray = dataShipmentDetail.Items
                    let tempShipDetailsString = filterService.advancedSearch(tempShipDetailArray.map(obj => {
                        return { name: 'Id', type: 'int32', operation: 'Equals', value: obj.IdBookingEquipment }
                    }))
                    tempShipDetailsString = tempShipDetailsString.replaceAll('and', 'or')
                    setAction('downloadVGM')
                    setDrawerEntity('bookingEquipment')
                    setDrawerLabel('Booking Equipment')
                    setFilter(new Map([[tempId.BookingNumber, `?page=1&pagesize=20${tempShipDetailsString}`]]))
                    setFilterName(tempId.BookingNumber)
                    setOnOpen(true)
                })
            })
        } else {
            ctx.toastMessages('error', '', t("SelectedLine"))
        }
    }

    const openDrawerDetailsVGM = () => {
        setShipId('')
        if (sessionStorage.getItem('contextLine') !== 'undefined') {
            setAnchorVGM(null)
            const tempId = JSON.parse(sessionStorage.getItem('contextLine'))
            if (tempId.BookingSummary === null) {
                ctx.toastMessages('error', '', t("BookingNoEquipments"))
                return
            }
            shipmentBuffer.filter(`?page=1&pagesize=20&filter=IdBooking eq ${tempId.Id}`).then(dataShipment => {
                if (dataShipment.name === 'AxiosError') {
                    ctx.toastMessages('error', dataShipment.message, '')
                    return
                }
                const tempShipArray = dataShipment.Items

                let tempShipString = filterService.advancedSearch(tempShipArray.map(obj => {
                    return { name: 'IdShipment', type: 'int32', operation: 'Equals', value: obj.Id }
                }))

                tempShipString = tempShipString.replaceAll('and', 'or')
                shipmentDetailsBuffer.filter(`?${tempShipString}`).then(dataShipmentDetail => {
                    if (dataShipment.name === 'AxiosError') {
                        ctx.toastMessages('error', dataShipmentDetail.message, '')
                        return
                    }

                    const tempShipDetailArray = dataShipmentDetail.Items
                    let tempShipDetailsString = filterService.advancedSearch(tempShipDetailArray.map(obj => {
                        return { name: 'Id', type: 'int32', operation: 'Equals', value: obj.IdBookingEquipment }
                    }))
                    tempShipDetailsString = tempShipDetailsString.replaceAll('and', 'or').replace('&filter=', '')

                    setAction('detailVGM')
                    setDrawerEntity('bookingEquipment')
                    setDrawerLabel('Booking Equipment')
                    setFILTERVGM(tempShipDetailsString)
                    setOpenElement(true)
                })
            })
        } else {
            ctx.toastMessages('error', '', t("SelectedLine"))
        }
    }

    const closeDrawer = () => {
        setOnOpen(false)
    }

    const closeElement = () => {
        setIsBookingEquipmentSelected(false)
        VGMDict.set('EquipmentType', '')
        VGMDict.set('EquipmentNumber', '')
        VGMDict.set('VGM', '')
        VGMDict.set('VGMWeight', '')
        VGMDict.set('VGMMethod', '')
        VGMDict.set('VGMDocumentNumber', '')
        VGMDict.set('Payload', undefined)
        VGMDict.set('Tare', undefined)
        setVGMDict(new Map(VGMDict))
        setOpenElement(false)
    }

    const getLine = (e) => {
        setShipId('')
        if (e.length !== 0 && e[0]) {
            setShipId(e[0])
        }
        if (action === 'detailVGM') {
            detailVGM(e[0])
        }
    }

    const drawerButtons = (passAction) => {
        if (shipId) {
            if (passAction === 'uploadVGM') handleClickVGM()
            if (passAction === 'downloadVGM') downloadVGM(shipId.VGMPath)
            if (passAction === 'uploadIMO') handleClickIMO()
            if (passAction === 'downloadIMO') downloadIMO(shipId.IMOPath)
        } else {
            ctx.toastMessages('error', '', t("SelectedLine"))
        }
    }

    const detailVGM = (e) => {
        if (e) {
            setIsBookingEquipmentSelected(true)
            // console.log(e)
            VGMDict.set('EquipmentType', `${e.EquipmentTypeLenght ? e.EquipmentTypeLenght : ''}${e.EquipmentTypeCode ? e.EquipmentTypeCode : ''}`)
            VGMDict.set('EquipmentNumber', `${e.Prefix ? e.Prefix : ''} ${e.Number ? e.Number : ''} ${e.CheckDigit ? e.CheckDigit : ''}`)
            VGMDict.set('VGM', Boolean(e.VGMPath))
            VGMDict.set('VGMWeight', e.VGMWeight ? e.VGMWeight : '')
            VGMDict.set('VGMMethod', e.VGMMethod ? e.VGMMethod : '')
            VGMDict.set('VGMDocumentNumber', e.VGMDocumentNumber ? e.VGMDocumentNumber : '')
            VGMDict.set('Payload', e.Payload !== null ? e.Payload : undefined)
            VGMDict.set('Tare', e.Tare !== null ? e.Tare : undefined)
        } else {
            setIsBookingEquipmentSelected(false)
            VGMDict.set('EquipmentType', '')
            VGMDict.set('EquipmentNumber', '')
            VGMDict.set('VGM', '')
            VGMDict.set('VGMWeight', '')
            VGMDict.set('VGMMethod', '')
            VGMDict.set('VGMDocumentNumber', '')
            VGMDict.set('Payload', undefined)
            VGMDict.set('Tare', undefined)

        }
        setVGMDict(new Map(VGMDict))
    }

    const buttonsVGM = [
        { label: 'Upload VGM', element: 'default', source: '/icons/svgsDaNet/upload.svg', style: { filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }, command: () => drawerButtons('uploadVGM') },
        { label: 'Download VGM', element: 'default', source: '/icons/svgsDaNet/download.svg', style: { filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }, command: () => drawerButtons('downloadVGM') }
    ]

    const element = () => {
        return (
            <>
                <div className='divTableDrawer' style={{ marginLeft: '10px' }}>
                    <h2 style={{ marginLeft: '10px', marginTop: '10px', marginBottom: '5px' }}>{'Booking Equipment'}</h2>
                    <M_Table
                        entityName={'bookingEquipment'}
                        useSessionStorage={false}
                        crud={false}
                        onPassLine={getLine}
                        tableHeight={'50vh'}
                        selectSingle={true}
                        extraButtons={buttonsVGM}
                        refresh={refreshSubTables}
                        setRefresh={setRefreshSubTables}
                        FILTER={FILTERVGM}
                    />
                </div>
                <M_Fieldset
                    labelInside
                    label={t("LabelVGMDetails")}
                    headerElement={
                        <div style={{ color: isBookingEquipmentSelected ? ctx.secondaryColor : 'var(--color-red)', fontSize: '18px', fontWeight: 'bold', marginRight: '40px' }} >
                            {isBookingEquipmentSelected ? `${VGMDict.get('EquipmentType') || ''} ${VGMDict.get('EquipmentNumber') || ''}` : t('SelectedLine')}
                        </div>
                    }
                    elements={
                        <div className="divTextfields">
                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '5px' }}>
                                <M_CheckBox
                                    label={'VGM'}
                                    checked={VGMDict.get('VGM') || false}
                                    disabled={!isBookingEquipmentSelected}
                                />
                            </div>
                            <div className='selectBooking'>
                                <M_Select
                                    label={'VGM Method'}
                                    value={VGMDict.get('VGMMethod') || ''}
                                    onChange={(e) => addValue('VGMMethod', e.target.value, VGMDict, setVGMDict)}
                                    disabled={!isBookingEquipmentSelected}
                                    options={[{ label: 'Method 1', value: 'Method 1' }, { label: 'Method 2', value: 'Method 2' }]}
                                />
                            </div>
                            <div className="individualTextfield">
                                <M_InputTextField
                                    label={'VGM Weight'}
                                    value={VGMDict.get('VGMWeight') || ''}
                                    color={VGMDict.get('VGMWeight') > VGMDict.get('Payload') + VGMDict.get('Tare') ? 'var(--color-red)' : null}
                                    secondColor={VGMDict.get('VGMWeight') > VGMDict.get('Payload') + VGMDict.get('Tare') ? 'var(--color-red)' : null}
                                    onChange={(e) => {
                                        addValue('VGMWeight', e.target.value, VGMDict, setVGMDict)
                                    }}
                                    disabled={!isBookingEquipmentSelected}
                                />
                            </div>
                            <div className="individualTextfield">
                                <M_InputTextField
                                    label={'VGM Document Number'}
                                    value={VGMDict.get('VGMDocumentNumber') || ''}
                                    onChange={(e) => addValue('VGMDocumentNumber', e.target.value, VGMDict, setVGMDict)}
                                    disabled={!isBookingEquipmentSelected}
                                />
                            </div>
                        </div>
                    }
                />
                {/* Precisa de levar traduções depois de completa esta tarefa */}
                {VGMDict.get('VGMWeight') > VGMDict.get('Payload') + VGMDict.get('Tare') ?
                    <p style={{ color: 'var(--color-red)', marginLeft: '50px' }}>{t('VGMTAREPAYLOAD')}({VGMDict.get('Payload')}) ! </p>
                    : ''
                }
                {/* Precisa de levar traduções depois de completa esta tarefa */}
                <div className='buttonSubmitIMO' style={{ margin: '20px', display: 'flex', justifyContent: 'end' }}>
                    <M_Button
                        hoverEffect
                        label={t("Save")}
                        backgroundColor={'var(--color-green)'}
                        labelColor={'var(--color-white)'}
                        onClick={() => saveVGM()}
                    />
                    {/* <GlobalButton click={() => saveVGM()} color={"success"} name={t("Save")} /> */}
                </div>
            </>
        )
    }

    const buttonsIMO = [
        { label: 'Upload IMO', element: 'default', source: '/icons/svgsDaNet/upload.svg', style: { filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }, command: () => drawerButtons('uploadIMO') },
        { label: 'Download IMO', element: 'default', source: '/icons/svgsDaNet/download.svg', style: { filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }, command: () => drawerButtons('downloadIMO') }
    ]

    const elementIMO = () => {
        return (
            <>
                <div className='divTableDrawer' style={{ marginLeft: '10px' }}>
                    <h2 style={{ marginLeft: '10px', marginTop: '10px', marginBottom: '5px' }}>{'Shipments'}</h2>
                    <M_Table
                        entityName={'shipment'}
                        useSessionStorage={false}
                        crud={false}
                        onPassLine={getLine}
                        selectSingle={true}
                        extraButtons={buttonsIMO}
                        refresh={refreshSubTables}
                        setRefresh={setRefreshSubTables}
                        FILTER={FILTERIMO}
                    />
                </div>
            </>
        )
    }

    const saveVGM = () => {
        if (VGMDict.get('VGMMethod') === '' || VGMDict.get('VGMMethod') === 'empty') {
            ctx.toastMessages('error', t("LabelVGMMethodMustBeFilled"), '')
            return
        }
        if (VGMDict.get('VGMWeight') > VGMDict.get('Payload') + VGMDict.get('Tare')) {
            ctx.toastMessages('error', t('VGMTAREPAYLOAD'), '')
            return
        }
        ctx.setIsLoad(true)
        // console.log(shipId)
        const tempObj = {
            IdEquipmentType: shipId.IdEquipmentType,
            VGMWeight: VGMDict.get('VGMWeight'),
            VGMMethod: VGMDict.get('VGMMethod'),
            VGMDocumentNumber: VGMDict.get('VGMDocumentNumber'),
        }
        bookingEquipmentService.update(shipId.Id, tempObj).then(res => {
            ctx.setIsLoad(false)
            // console.log(res)
            if (res.name === 'AxiosError') {
                ctx.toastMessages('error', res.message, '')
                return
            }
            ctx.toastMessages('success', t("LabelDetailsSaved"), '')
            setRefreshSubTables(true)
        })
    }

    const addValue = (key, value, dict, setDict) => {
        dict.set(key, value)
        setDict(new Map(dict))
    }

    const downloadVGM = (path) => {
        const url = `${DefaultURl}download`

        axios({
            method: 'post',
            responseType: 'arraybuffer',
            url: url,
            data: `${path}`,
            headers: { 'Content-Type': 'application/json' }
        }).then(res => {
            let fileName = 'VGM.pdf'
            const blob = new Blob([res.data], {
                type: 'application/octet-stream'
            })
            saveAs(blob, fileName)
            ctx.toastMessages('success', t("LabelDownloadedVGMFile"), '')
            setRefreshSubTables(true)
        }).catch(error => {
            if (error.name === 'AxiosError') {
                ctx.toastMessages('error', error.message, '')
                setRefreshSubTables(true)
            }
        })
    }

    const downloadIMO = (path) => {
        const url = `${DefaultURl}download`

        axios({
            method: 'post',
            responseType: 'arraybuffer',
            url: url,
            data: `${path}`,
            headers: { 'Content-Type': 'application/json' }
        }).then(res => {
            let fileName = 'IMO.pdf'
            const blob = new Blob([res.data], {
                type: 'application/octet-stream'
            })
            saveAs(blob, fileName)
            ctx.toastMessages('success', t("LabelDownloadedIMOFile"), '')
            setRefreshSubTables(true)
        }).catch(error => {
            if (error.name === 'AxiosError') {
                ctx.toastMessages('error', error.message, '')
                setRefreshSubTables(true)
            }
        })
    }

    const handleClickVGM = () => {
        hiddenFileInputUploadVGM.current.click()
    }

    const handleClickIMO = () => {
        hiddenFileInputUploadIMO.current.click()
    }

    const handleChangeUploadVGM = (data) => {
        //Se o ficheiro for undifined nao chama o post e dá return
        if (data.target.files[0] === undefined) return
        ctx.setIsLoad(true)
        const temp = data.target.files[0]
        const formData = new FormData()
        formData.append(
            "file",
            temp,
        )
        const url = `${DefaultURl}upload/bookingEquipment/${shipId.Id}`

        axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
            // console.log(response)
            ctx.setIsLoad(false)
            ctx.toastMessages('success', t("LabelUploadedVGMFile"), '')
            setRefreshSubTables(true)
            // setFile(response.data)
        }).catch(error => {
            ctx.setIsLoad(false)
            if (error.name === 'AxiosError') {
                ctx.toastMessages('error', error.message, '')
                setRefreshSubTables(true)
            }
            // console.log(error)
        })
    }

    const handleChangeUploadIMO = (data) => {
        //Se o ficheiro for undifined nao chama o post e dá return
        if (data.target.files[0] === undefined) return
        ctx.setIsLoad(true)
        const temp = data.target.files[0]
        const formData = new FormData()
        formData.append(
            "file",
            temp,
        )
        const url = `${DefaultURl}upload/shipment/${shipId.Id}`

        axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
            ctx.setIsLoad(false)
            // console.log(response)
            ctx.toastMessages('success', t("LabelUploadedIMOFile"), '')
            // setFile(response.data)
            setRefreshSubTables(true)
        }).catch(error => {
            ctx.setIsLoad(false)
            if (error.name === 'AxiosError') {
                ctx.toastMessages('error', error.message, '')
                setRefreshSubTables(true)
            }
            // console.log(error)
        })
    }

    const saveline = (obj) => {
        sessionStorage.setItem('context', JSON.stringify(obj))
        operationBookingContext("go/createBooking", 'Create')
    }

    const moveBooking = (obj) => {
        ctx.setIsLoad(true)
        let tempLines = ''
        if (sessionStorage.getItem('lines')) {
            tempLines = JSON.parse(sessionStorage.getItem('lines'))
        } else {
            ctx.toastMessages('error', '', t("SelectedLine"))
            ctx.setIsLoad(false)
            return
        }

        const move = {
            "newTransportId": obj.Id,
            "bookings": tempLines.map(line => line.Id)
        }

        MoveService.update('', move).then(res => {
            if (res.name === 'Axios Error') {
                ctx.toastMessages('error', res.message, '')
                ctx.setIsLoad(false)
                return
            }
            ctx.toastMessages('success', '', res)
            ctx.setIsLoad(false)
            setRefresh(true)
        })
    }

    const viewBL = (url, label) => {
        let tempLine = sessionStorage.getItem('context')

        if (tempLine === 'undefined' || tempLine === null || tempLine === 'null' || tempLine === undefined) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }

        tempLine = JSON.parse(tempLine)

        if (tempLine.BLId && tempLine.BLId !== '00000000-0000-0000-0000-000000000000') {
            BLService.getId(tempLine.BLId).then(res => {
                // console.log(res)
                if (res.name === 'Axios Error') {
                    ctx.toastMessages('error', res.message, '')
                    return
                }
                // console.log(res)
                sessionStorage.setItem('blContext', JSON.stringify(res))
                NewRoute(url, label)
            })
        } else {
            ctx.toastMessages('error', '', t("LabelFirstCreateBL"))
        }

    }

    // eslint-disable-next-line
    const multiButtonsIMO = () => {
        return (
            <Menu
                anchorEl={anchorIMO}
                open={openIMO}
                onClose={() => setAnchorIMO(null)}
                className="menuExcel"
            >
                {/* <MenuItem key='upload' className='menuItem' onClick={() => console.log('teste')}>Upload</MenuItem> */}
                <MenuItem className='menuItem' onClick={() => openDrawerUploadIMO()}><img style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }} src='/icons/svgsDaNet/upload.svg' alt={'uploadIMO'} className="iconTable" />Upload IMO</MenuItem>
                <MenuItem className='menuItem' onClick={() => openDrawerDetailsIMO()}><img style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }} src='/icons/svgsDaNet/download.svg' alt={'downloadIMO'} className="iconTable" /> Download IMO</MenuItem>
            </Menu>
        )
    }

    // eslint-disable-next-line
    const multiButtonsVGM = () => {
        return (
            <Menu
                anchorEl={anchorVGM}
                open={openVGM}
                onClose={() => setAnchorVGM(null)}
                className="menuExcel"
            >
                {/* <MenuItem key='upload' className='menuItem' onClick={() => console.log('teste')}>Upload</MenuItem> */}
                <MenuItem className='menuItem' onClick={() => openDrawerDetailsVGM()}> <img style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }} src='/icons/svgsDaNet/search.svg' alt={'downloadVGM'} className="iconTable" />VGM Details</MenuItem>
                <MenuItem className='menuItem' onClick={() => openDrawerUploadVGM()}>  <img style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }} src='/icons/svgsDaNet/upload.svg' alt={'uploadVGM'} className="iconTable" />Upload VGM</MenuItem>
                <MenuItem className='menuItem' onClick={() => openDrawerDownloadVGM()}> <img style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }} src='/icons/svgsDaNet/download.svg' alt={'downloadVGM'} className="iconTable" />Download VGM</MenuItem>
            </Menu>
        )
    }

    const onHide = (e) => {
        setIsLabel(e)
    }

    const removeContextItems = ['View', 'Create', 'Edit', 'Print']

    const getLineBooking = (e) => {
        if (e.length) {
            sessionStorage.setItem('lines', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('lines')
        }
    }

    const getContextBooking = (e) => {
        // console.log(e)
        if (e) {
            sessionStorage.setItem('context', JSON.stringify(e))
            sessionStorage.setItem('bookingLine', JSON.stringify(e)) // Para o menu
            updatePermissions()
        } else {
            // sessionStorage.removeItem('context')
        }
    }

    return (
        <>
            <M_Table
                entityName={'booking'}
                rolePermissions={roles}
                tablesOrder={tablesOrder}
                onTablesOrderUpdate={onTablesOrderUpdate}
                pageUrl={'Bookings'}
                lineContext={getPermissions('Context')}
                extraButtons={getPermissions('Buttons')}
                lineContext={contextMenu}
                extraButtons={extraButtons}
                removeContextItems={removeContextItems}
                onHideLabels={onHide}
                onPassLine={getLineBooking}
                onPassContext={getContextBooking}
                refresh={refresh}
                setRefresh={setRefresh}
                toUseFilter={filter}
                toUseFilterName={filterName}
                hiddenColumns={['Changes']}
            // FILTER={filter}
            />
            <M_ElementDrawer
                open={openElement}
                setOpen={setOpenElement}
                onClose={closeElement}
                element={element()}
            />
            <M_ElementDrawer
                open={onOpen}
                setOpen={setOnOpen}
                onClose={closeDrawer}
                element={elementIMO()}
            />
            <input
                type="file"
                ref={hiddenFileInputUploadIMO}
                onChange={handleChangeUploadIMO}
                style={{ display: 'none' }}
            />
            <input
                type="file"
                ref={hiddenFileInputUploadVGM}
                onChange={handleChangeUploadVGM}
                style={{ display: 'none' }}
            />
            <M_MessageBoard
                warning
                open={openDeleteContext}
                onClose={() => setOpenDeleteContext(false)}
                title={`${t("Delete")} ${t("Booking")}?`}
                body={<span>
                    {t("TitleConfirmDelete")} <b>{t("Booking")}</b>
                </span>}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenDeleteContext(false)}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t("Delete")}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteBookingContext()}
                        />
                    </div>

                }
            />
            <M_MessageBoard
                warning
                open={openDeleteLine}
                onClose={() => setOpenDeleteLine(false)}
                title={`${t("Delete")} ${t("Booking")}?`}
                body={<span>
                    {t("TitleConfirmDelete")} <b>{t("Booking")}</b>
                </span>}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenDeleteLine(false)}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t("Delete")}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteBookingLine()}
                        />
                    </div>
                }
            />
            <M_MessageBoard
                open={confirmModal}
                onClose={() => {
                    setTransportValue(null)
                    setConfirmModal(false)
                }}
                title={t("ConfirmMoveBookings")}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                setTransportValue(null)
                                setConfirmModal(false)
                            }}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonConfirm")}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                moveBooking(transportValue)
                                setConfirmModal(false)
                            }}
                        />
                    </div>
                }
            />
        </>
    )
}

export default BookingList